import React from "react";
import sanitizeHtml from "sanitize-html";

type Props = {
  html: string;
};

const Santizer: React.FC<Props> = (props) => {
  return (
    <span
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(props.html) }}
    />
  );
};

export default Santizer;
